import React from "react";
import NavBar from "./NavBar";
import MainContent from "./MainContent";

const App = () => [<NavBar key="navbar" />, <MainContent key="main-content" />];

export default App;



// WEBPACK FOOTER //
// ./src/App.js